import React, { FunctionComponent } from 'react';
import { Text } from '@mlc/web-ui-toolkit';

const SomethingWentWrong: FunctionComponent = () => {
	return (
		<Text>
			<strong>Something went wrong.</strong> Please try again later or contact
			MLC on <b>133 652</b>.
		</Text>
	);
};

export { SomethingWentWrong };
